import * as angular from "angular";
import { CanvassStatus } from "../models/canvass-status.model";

export class CanvassStatusService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/canvass/status";
        this.v2Root = "/v2/canvass/status";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot);
    }

    canvassCount(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/count/" + data.id, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.id, data);
    }

    migrate(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/migrate", data);
    }

    updateOrder(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/updateOrder", data);
    }

    updateAll(data: CanvassStatus[]): Promise<object> {
        return this.$http.post(this.v2Root + "/update/all", { statuses: data });
    }

    workflows(data: CanvassStatus[]): Promise<object> {
        return this.$http.post(this.v2Root + "/workflows", {
            statuses: data,
        });
    }
    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }
}

angular
    .module("vcServices")
    .service("CanvassStatusService", CanvassStatusService);
